define((require) => {
    "use strict";

    var AnalyticsView     = require("ui/settings/analytics/AnalyticsView"),
        EditorEvents      = require("shared/services/EditorEvents"),
        LoggedInUserState = require("shared/ui/user/LoggedInUserState"),
        Marionette        = require("marionette"),
        SystemMessages    = require("editor/services/SystemMessages"),
        {isBlank}         = require("shared/util/StringUtils"),
        Syncer            = require("shared/services/sync/Syncer"),
        SyncManager       = require("shared/services/sync/SyncManager");

    return Marionette.Controller.extend({

        showAnalytics: function() {
            var settings  = LoggedInUserState.get("companySettings"),
                view      = new AnalyticsView({model: settings}),
                changed   = null,
                operation = null,
                analyticsName = null;

            this.options.region.show(view);

            // Listen to validated changes on the *view*, not the model. This ensures we only sync when a valid
            // analytics key has been entered, not on every keystroke. However, we know the settings model is still
            // bound to view, so the relevant attribute will have changed as well, we just know that it is a valid
            // change here. When ever a sync is about to start, we disable the *other* analytics settings field to
            // avoid cascading saves if the user flips tabs while a pending is pending; once the save completes,
            // the input of the switched to tab becomes active again...

            this.listenTo(view, "change", () => {
                changed = null;
                analyticsName = null;
                operation = "saved";

                var key = settings.changed.googleAnalyticsId;

                if (typeof key !== "undefined") {
                    changed = "Your Google Analytics Tracking ID";
                    analyticsName = "GoogleAnalytics";
                    if (isBlank(key)) {
                        operation = "removed";
                    } else {
                        changed += " &quot;" + key + "&quot;";
                    }

                    view.ui.segmentIoApiKey.attr("disabled", true); // input in other tab!
                } else {
                    key = settings.changed.segmentIoApiKey;

                    if (typeof key !== "undefined") {
                        changed = "Your Segment.io Write Key";
                        analyticsName = "Segment.com";
                        if (isBlank(key)) {
                            operation = "removed";
                        } else {
                            changed += " &quot;" + key + "&quot;";
                        }

                        view.ui.googleAnalyticsId.attr("disabled", true); // input in other tab!
                    }
                }

                if (changed) {
                    settings.saveLater();
                }
            });

            // Listen for sync changes on the settings *model* to notify the user about CDN information...
            SyncManager.onSync({
                context: this,
                target:  settings,
                method:  "save",
                state:   null, // any "save" state
                callback: function(state) {
                    if (changed) {
                        if (state === Syncer.State.Synced) {
                            var purgeTime = settings.get("purgeTime");
                            // Only open the notification bar if the purgeTime is not null
                            if (purgeTime !== null) {
                                SystemMessages.notifyPurge(changed, operation, purgeTime, false);

                                var eventName = EditorEvents.constants.SAVE_INTEGRATION;

                                if (operation === "removed") {
                                    eventName = EditorEvents.constants.DELETE_INTEGRATION;
                                }

                                var eventProperties = {
                                    category: "Analytics",
                                    integrationType: analyticsName,
                                    triggerOrigin: "AnalyticsInputField"
                                };

                                EditorEvents.trigger(eventName, eventProperties);
                            }
                        }

                        if (Syncer.State.complete(settings)) {
                            if (!view.isClosed) {
                                view.ui.googleAnalyticsId.attr("disabled", false);
                                view.ui.segmentIoApiKey.attr("disabled",   false);
                            }

                            changed = null;
                        }
                    }
                }
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/analytics/AnalyticsController.js